<template>
  <header class="text-center bg-blue-800 text-white p-4 mb-10">
    <div class="text-3xl md:text-5xl font-bold "><i class="fa fa-viruses"></i>Covid Tracker</div>
  </header>
</template>

<script>
export default {
  name: 'Header',
}
</script>